import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {GROWTH_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {FONT_PROXIMA_15} from 'styles/FontConstants';
import Avatar from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {GRAY_DARKER} from 'ui-library/Colors';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';

import {ShareLinkMetadata} from '../ShareLinkConstants';

export const SHARE_METADATA_MODAL_KEY = 'growth-experiment-share-link-metadata-modal';

export default function ShareMetadataModal(props: ShareLinkMetadata): JSX.Element {
  const onClose = (): void => {
    ModalContainer.close(SHARE_METADATA_MODAL_KEY);
    analytics.trackEvent(GROWTH_ANALYTICS_ACTIONS.CLOSED_SHARE_LINK_METADATA_MODAL, {
      metadataIdentifier: props.publicIdentifier,
    });
  };

  return (
    <Modal
      title="Welcome to Benchling!"
      onRequestClose={() => {
        onClose();
      }}
      onRequestSubmit={() => {
        onClose();
      }}
      buttons={[{submit: true, text: 'Open'}]}
      dataTestAttrs={{component: 'ShareMetadataModal', element: 'root'}}
    >
      <div>
        <Avatar entity={props.creator} size={AvatarSize.XXSMALL} /> <strong>{props.creator.name}</strong> has
        shared a file with you.
      </div>
      <div className={css(styles.description)}>
        {props.description.split('\n').map((line) => (
          <p key={line.slice(0, 10)}>{line}</p>
        ))}
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  description: {
    ...FONT_PROXIMA_15,
    color: GRAY_DARKER,
    marginTop: '15px',
  },
});
